export default __webpack_public_path__ + "static/media/instaicon.fdbaa1c0.svg";